import { ApolloClient } from 'apollo-client';
import { InMemoryCache, InMemoryCacheConfig } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink, Observable } from 'apollo-link';

export const createCache = (options: InMemoryCacheConfig) => {
  const cache = new InMemoryCache(options);

  return cache;
};

const createLink = () =>
  new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        let handle: ZenObservable.Subscription;

        Promise.resolve(operation)
          .then(() => {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            });
          })
          .catch(observer.error.bind(observer));
        return () => {
          if (handle) handle.unsubscribe();
        };
      })
  );

// log erors
// eslint-disable-next-line no-console
const logError = (...args: any[]) => console.error(args);

// create error link
const createErrorLink = () =>
  onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      logError('GraphQL - Error', {
        errors: graphQLErrors,
        operationName: operation.operationName,
        variables: operation.variables,
      });
    }
    if (networkError) {
      logError('GraphQL - NetworkError', networkError);
    }
  });

// http link
const createHttpLink = () => {
  return new HttpLink({
    uri: `//${process.env.MONOLITH_DOMAIN}/lit/graphql`,
    credentials: 'include',
    headers: {
      'x-vercel-bypass': import.meta.env.VITE_CLOUDFLARE_BYPASS_TOKEN as string,
    },
  });
};

export const createClient = (cache: InMemoryCache) =>
  new ApolloClient({
    link: ApolloLink.from([createErrorLink(), createLink(), createHttpLink()]),
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'cache-first',
      },
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
